import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import API_URL from '../config/api';
import { Link } from "react-router-dom";
import './Dashboard.css';

const Dashboard = () => {
  const { user, token, loading } = useAuth();
  const [loans, setLoans] = useState([]);

  useEffect(() => {
    const fetchLoans = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found in localStorage");
          return;
        }

        const response = await axios.get(`${API_URL}/api/loans`, {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ this is critical
          },
        });
        // server returns either an array or { data: { loans: [...] }} depending on route
        const respLoans = Array.isArray(response.data) ? response.data : (response.data.data ? response.data.data.loans : response.data.loans || []);
        setLoans(respLoans);
      } catch (err) {
        console.error(err);
      }
    };

    if (token) {
      fetchLoans();
    }
  }, [token]);

  if (loading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-5">
      <div className="py-6">
        <div className="text-center">
          {user ? (
            <h1 className="h3 fw-bold text-dark">Welcome, {user.firstName ?? user.email ?? 'User'}!</h1>
          ) : (
            <h1 className="h3 fw-bold text-dark">Welcome!</h1>
          )}
          <p className="mt-2 text-primary fw-bold fs-1">Your loan dashboard</p>
        </div>
        <div className="container">
          {/* Header Section */}
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold">
              SmartLend Nigeria
              <div className="text-primary">Fintech + Solar Loan Platform</div>
            </h1>
            <p className="lead mt-3">
              Get instant access to cash loans and solar financing with
              SmartLend Nigeria. Apply now with just your BVN.
            </p>
          </div>

          {/* Features Section */}
          <div className="row text-center g-4 mb-4 loan-features">
            {/* Cash Loans */}
            <div className="col-md-5 loan-feature-card">
              <h5>Cash Loans</h5>
              <h3 className="fw-bold">Quick & Secure Financing</h3>
              <p>
                Get access to cash loans from ₦2,000 to ₦100,000 with flexible
                repayment options.
              </p>
              <Link to="/loan-application" className="apply-btn text-danger fw-bold fs-5">
                Click Here to Apply for Cash Loan
              </Link>
            </div>

            {/* Solar Loans */}
            <div className="col-md-6 loan-feature-card">
              <h5>Solar Loans</h5>
              <h3 className="fw-bold">Clean Energy Financing</h3>
              <p>
                Get access to Finance DABEEL solar kits with flexible repayment options for up to 4
                months.
              </p>
              <Link to="/loan-application" className="apply-btn text-danger fs-5 fw-bold">
                Click Here to Apply for Solar Loan
              </Link>
            </div>
          </div>
        </div>

        <div className="loan-list-wrapper">
          <div className="loan-list">
            <div className="text-center">
              <h2 className="text-xl font-semibold mb-2">Your Loans</h2>
              <hr />
            </div>

            {loans.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-muted">You have no active loans.</p>
                <button
                  onClick={() => (window.location.href = "/loan-application")}
                  className="apply-btn text-danger fw-bold fs-5"
                  style={{ marginTop: 16 }}
                >
                  Apply for Loan
                </button>
              </div>
            ) : (
              <div>
                {loans.map((loan) => (
                  <div key={loan._id} className="loan-card">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h3>{loan.type === "cash" ? "Cash Loan" : "Solar Loan"}</h3>
                        <p className="loan-amount">Amount: ₦{loan.amount.toLocaleString()}</p>
                      </div>
                      <div>
                        <span className={`loan-badge ${
                          loan.status.toLowerCase() === 'pending' ? 'loan-pending' : 
                          loan.status.toLowerCase() === 'approved' ? 'loan-approved' : 
                          loan.status.toLowerCase() === 'repaying' ? 'loan-repaying' : 
                          'loan-declined'
                        }`}>
                          {loan.status}
                        </span>
                        </div>
                          {String(loan.status).toLowerCase() === 'rejected' && loan.rejectionReason ? (
                            <div className="rejection-reason">
                              <h5 className="text-danger">Rejection Reason</h5>
                              <p className="text-muted">{loan.rejectionReason}</p>
                            </div>
                          ) : null}
                    </div>

                    <div style={{ marginTop: 12 }}>
                      <h4 className="text-sm font-medium">Repayment Schedule</h4>
                      <div style={{ marginTop: 8 }}>
                        {loan.repaymentSchedule.map((payment, index) => (
                          <div key={index} className="repayment-item">
                            <div className="due-date">{new Date(payment.dueDate).toLocaleDateString()}</div>
                            <div className="amount">₦{payment.amount.toLocaleString()}</div>
                            <div className={`repayment-status ${payment.status === 'Pending' ? 'repay-pending' : payment.status === 'Paid' ? 'repay-paid' : 'repay-overdue'}`}>
                              {payment.status}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
